import React from 'react'
import { Typography, Skeleton } from 'antd';

const { Title, Text } = Typography;

const titleStyle = {
    color: "white",
    margin:"80px"
}

function Contact() {
    const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.907712660752!2d127.0245612155874!3d37.51009473511562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3e508666093%3A0xfefb1b7ffa7a2d12!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDtlZnrj5nroZwyMOq4uCA2MA!5e0!3m2!1sko!2skr!4v1663689373968!5m2!1sko!2skr";
  return (
    <div>
        <Title level={1} style={titleStyle}>Contact Us</Title>
        <iframe src={mapUrl} width="50%" height="450px" style={{border:"none"}} loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <div style={{display:"flex", flexDirection:"column",textAlign:"left", justifyContent:"space-between", width:"50%", height:"130px", margin:"50px auto"}}>        
        <Text level={4} style={{color:"white", margin:"0px"}}>SPACE BE</Text>
        <Text level={5} style={{color:"white", margin:"0px"}}>주소 : 서울특별시 강남구 학동로20길 60, 301호 ㈜공간스페이스비</Text>
        <Text level={5} style={{color:"white", margin:"0px"}}>문의 : spacebe@spacebe.kr
          <p style={{marginLeft:"40px"}}>070-7625-5678</p>
        </Text>        
        </div>
    </div>
  )
}

export default Contact